/**
 * =====================================================
 *  WHISPERING HOMES — Picked For Your Taste (Recently Viewed)
 *  File: assets/picked-for-you.js
 *
 *  Sirf "Recently Viewed" handle karta hai (upsell/category-pair
 *  part ab picked-for-you.liquid me server-side render hota hai).
 *
 *  Recently-viewed cards ko EXACT same card-product markup se
 *  dikhane ke liye, ye har recently-viewed product ke apne page
 *  se uska "self card" fetch karta hai (Shopify Section Rendering
 *  API: /products/{handle}?section_id={id}), phir us page ke
 *  andar chhupa <template data-self-card> nikal ke istemal karta
 *  hai — matlab asli Liquid-rendered HTML, koi manual markup
 *  duplicate nahi karna padta.
 *
 *  SLIDER: "Single Collection Slider" (Best Seller) jaisa hi
 *  wh-sc carousel — cards div.wh-sc__card hote hain (li nahi),
 *  track div.wh-sc__track hota hai.
 *
 *  Section ka wh-sc wrapper "data-sc-manual-init=true" ke sath
 *  render hota hai, matlab wh-single-collection-slider.js khud-se
 *  ise init nahi karega. Hum yahan:
 *    1. Pehle recently-viewed cards fetch + insert karte hain
 *       (track ke sabse aage),
 *    2. Phir window.initWhSc(sectionId) call karte hain —
 *       taaki carousel sahi total-card-count ke sath init ho
 *       (upsell + recently-viewed dono clone-logic me shamil ho).
 * =====================================================
 */

window.WhisperingPickedForYou = (() => {

  const RECENTLY_VIEWED_KEY = 'wh_recently_viewed';
  const RECENTLY_VIEWED_MAX = 12; // localStorage me kitne handles max store honge

  const _f = () => {
    if (!window._whNativeFetch) {
      window._whNativeFetch = window.fetch.bind(window);
    }
    return window._whNativeFetch;
  };

  // ─────────────────────────────────────────────────────────────────
  //  LOCALSTORAGE HELPERS
  // ─────────────────────────────────────────────────────────────────
  function getStoredHandles() {
    try {
      return JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function trackCurrentProduct(handle) {
    if (!handle) return;
    try {
      let handles = getStoredHandles().filter(h => h !== handle);
      handles.unshift(handle); // sabse recent sabse aage
      handles = handles.slice(0, RECENTLY_VIEWED_MAX);
      localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(handles));
    } catch (e) {
      console.error('[PickedForYou] trackCurrentProduct error:', e);
    }
  }

  // ─────────────────────────────────────────────────────────────────
  //  FETCH REAL CARD HTML VIA SECTION RENDERING API
  // ─────────────────────────────────────────────────────────────────
  async function fetchSelfCardHtml(handle, sectionId) {
    try {
      const url = `/products/${handle}?section_id=${sectionId}`;
      const res = await _f()(url);
      if (!res.ok) return null;
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const template = doc.getElementById(`picked-for-you-self-card-${sectionId}`);
      if (!template || !template.content) return null;
      const card = template.content.querySelector('.wh-sc__card');
      return card ? card.outerHTML : null;
    } catch (e) {
      console.error('[PickedForYou] fetchSelfCardHtml error for', handle, e);
      return null;
    }
  }

  // ─────────────────────────────────────────────────────────────────
  //  INIT
  // ─────────────────────────────────────────────────────────────────
  async function init(containerId) {
    const container = document.getElementById(containerId);
    if (!container) return;

    const sectionId = container.dataset.sectionId;
    const currentHandle = container.dataset.productHandle;
    const recentSlots = parseInt(container.dataset.recentlyViewedSlots || '3', 10);
    const listEl = container.querySelector(`#PickedForYou-List-${sectionId}`);

    if (!listEl || !sectionId) return;

    // 1. current product ko recently-viewed me save karo
    trackCurrentProduct(currentHandle);

    // 2. agar recently-viewed slots chahiye, cards fetch + insert karo
    //    (isse PEHLE carousel init nahi karna — clone-logic ko sahi
    //    total count chahiye)
    if (recentSlots > 0) {
      const handles = getStoredHandles()
        .filter(h => h !== currentHandle)
        .slice(0, recentSlots);

      if (handles.length) {
        const cardsHtml = await Promise.all(handles.map(h => fetchSelfCardHtml(h, sectionId)));
        const validCards = cardsHtml.filter(Boolean);

        if (validCards.length) {
          const wrapper = document.createElement('div');
          wrapper.innerHTML = validCards.join('');
          while (wrapper.firstChild) {
            listEl.insertBefore(wrapper.firstChild, listEl.firstChild);
          }
        }
      }
    }

    // 3. Ab jab saare cards (upsell + recently viewed) DOM me aa chuke
    //    hain, wh-sc carousel ko manually initialize karo.
    if (window.initWhSc) {
      window.initWhSc(sectionId);
    } else {
      console.warn('[PickedForYou] initWhSc not found — check that wh-single-collection-slider.js loaded before this script.');
    }
  }

  return { init };

})();